import { throwError } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var ContentTypes;

(function (ContentTypes) {
  ContentTypes["Anything"] = "*/*";
  ContentTypes["Bmp"] = "image/bmp";
  ContentTypes["Css"] = "text/css";
  ContentTypes["Csv"] = "text/csv";
  ContentTypes["FormData"] = "application/x-www-form-urlencoded";
  ContentTypes["Gif"] = "image/gif";
  ContentTypes["Gzip"] = "application/gzip";
  ContentTypes["Html"] = "text/html";
  ContentTypes["Jpeg"] = "image/jpeg";
  ContentTypes["Json"] = "application/json";
  ContentTypes["Mp3"] = "audio/mp3";
  ContentTypes["Mpeg"] = "audio/mpeg";
  ContentTypes["MultipartFormData"] = "multipart/form-data";
  ContentTypes["OctetStream"] = "application/octet-stream";
  ContentTypes["Pdf"] = "application/pdf";
  ContentTypes["Png"] = "image/png";
  ContentTypes["Svg"] = "image/svg+xml";
  ContentTypes["Text"] = "text/plain";
  ContentTypes["Xml"] = "application/xml";
  ContentTypes["Zip"] = "application/zip";
})(ContentTypes || (ContentTypes = {}));

var Http = /*#__PURE__*/function () {
  function Http(config) {
    var headers = !config.headers.Accept && !config.headers.accept ? _extends({}, config.headers, {
      Accept: ContentTypes.Json
    }) : config.headers;
    this.configuration = _extends({}, config, {
      headers: headers
    });
  }

  var _proto = Http.prototype;

  _proto.accept = function accept() {
    for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
      types[_key] = arguments[_key];
    }

    var config = _extends({}, this.configuration, {
      headers: _extends({}, this.configuration.headers, {
        Accept: types.join(', ')
      })
    });

    return new Http(config);
  };

  _proto.bearer = function bearer(token) {
    if (!token) {
      return new Http(this.configuration);
    }

    var config = _extends({}, this.configuration, {
      headers: _extends({}, this.configuration.headers, {
        Authorization: "Bearer " + token
      })
    });

    return new Http(config);
  };

  _proto.errorTransform = function errorTransform(method) {
    var config = _extends({}, this.configuration, {
      errorTransform: method
    });

    return new Http(config);
  };

  _proto.body = function body(content) {
    var config = _extends({}, this.configuration, {
      body: content
    });

    return new Http(config);
  };

  _proto.contentType = function contentType(type) {
    var config = _extends({}, this.configuration, {
      headers: _extends({}, this.configuration.headers, {
        'Content-Type': type
      })
    });

    return new Http(config);
  };

  _proto["delete"] = function _delete() {
    return this.requestWithBody('DELETE');
  };

  _proto.get = function get() {
    return httpRequest(this.getFullUrl(), {
      headers: this.configuration.headers,
      method: 'GET'
    }, this.configuration.errorTransform);
  };

  _proto.head = function head() {
    return httpRequest(this.getFullUrl(), {
      headers: this.configuration.headers,
      method: 'HEAD'
    }, this.configuration.errorTransform);
  };

  _proto.header = function header(name, value) {
    var _extends2;

    var config = _extends({}, this.configuration, {
      headers: _extends({}, this.configuration.headers, (_extends2 = {}, _extends2[name] = value, _extends2))
    });

    return new Http(config);
  };

  _proto.options = function options() {
    return httpRequest(this.getFullUrl(), {
      headers: this.configuration.headers,
      method: 'OPTIONS'
    }, this.configuration.errorTransform);
  };

  _proto.patch = function patch() {
    return this.requestWithBody('PATCH');
  };

  _proto.post = function post() {
    return this.requestWithBody('POST');
  };

  _proto.put = function put() {
    return this.requestWithBody('PUT');
  };

  _proto.query = function query(_query) {
    var queryString;

    if (_query instanceof URLSearchParams) {
      queryString = _query.toString();
    } else if (typeof _query === 'string') {
      queryString = _query;
    } else {
      var params = new URLSearchParams();
      Object.keys(_query).forEach(function (key) {
        if (Array.isArray(_query[key])) {
          _query[key].forEach(function (param) {
            params.append(key, param);
          });
        } else {
          params.append(key, _query[key]);
        }
      });
      queryString = params.toString();
    }

    var config = _extends({}, this.configuration, {
      query: queryString
    });

    return new Http(config);
  };

  _proto.url = function url(_url) {
    var config = _extends({}, this.configuration, {
      url: _url
    });

    return new Http(config);
  }
  /**
   * Private functions
   */
  ;

  _proto.getFullUrl = function getFullUrl() {
    var _this$configuration$u = this.configuration.url,
        url = _this$configuration$u === void 0 ? '' : _this$configuration$u;

    if (this.configuration.query) {
      url += url.indexOf('?') < 0 ? '?' : '&';
      url += this.configuration.query;
    }

    return url;
  };

  _proto.requestWithBody = function requestWithBody(method) {
    var _this = this;

    var headers = _extends({}, this.configuration.headers);

    if (!headers['Content-Type']) {
      headers['Content-Type'] = ContentTypes.Json;
    }

    var body = '';

    if (this.configuration.body && typeof this.configuration.body === 'object') {
      if (headers['Content-Type'] === ContentTypes.FormData) {
        var encoded = new URLSearchParams();
        Object.keys(this.configuration.body).forEach(function (key) {
          return (// eslint-disable-next-line @typescript-eslint/no-explicit-any
            encoded.append(key, _this.configuration.body[key])
          );
        });
        body = encoded.toString();
      } else {
        body = JSON.stringify(this.configuration.body);
      }
    } else if (this.configuration.body && typeof this.configuration.body === 'string') {
      body = this.configuration.body;
    }

    return httpRequest(this.getFullUrl(), {
      body: body,
      headers: headers,
      method: method
    }, this.configuration.errorTransform);
  };

  return Http;
}();
function http(url) {
  return new Http({
    headers: {},
    url: url
  });
}
/**
 * HTTP functions using fromFetch
 */

function convertResponse(_ref, data) {
  var respHeaders = _ref.headers,
      status = _ref.status,
      statusText = _ref.statusText,
      url = _ref.url;
  var headers = {};
  respHeaders === null || respHeaders === void 0 ? void 0 : respHeaders.forEach(function (value, key) {
    headers[key] = value;
  });
  return {
    data: data,
    headers: headers,
    status: status,
    statusText: statusText,
    url: url
  };
}

function httpRequest(url, options, errorTransform) {
  return fromFetch(url, options).pipe(switchMap(function (response) {
    try {
      var _temp7 = function _temp7(_result) {
        var _response$headers$get;

        if (_exit2) return _result;

        function _temp4() {
          return convertResponse(response, data);
        }

        var data;
        var contentTypes = (_response$headers$get = response.headers.get('content-type')) === null || _response$headers$get === void 0 ? void 0 : _response$headers$get.split(',');

        var _temp3 = function () {
          if ((contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Bmp)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Gif)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Jpeg)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Mp3)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Mpeg)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Pdf)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Png)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Gzip)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.OctetStream)) || (contentTypes === null || contentTypes === void 0 ? void 0 : contentTypes.includes(ContentTypes.Zip))) {
            return Promise.resolve(response.blob()).then(function (_response$blob) {
              data = _response$blob;
            });
          } else {
            return Promise.resolve(response.text()).then(function (text) {
              var isJson = !!text && (text[0] === '{' || text[0] === '[');

              try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                data = isJson ? JSON.parse(text) : text;
              } catch (_unused) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                data = text;
              }
            });
          }
        }();

        return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
      };

      var _exit2 = false;

      var _temp8 = function () {
        if (!response.ok) {
          var _temp9 = function _temp9() {
            throw _error;
          };

          var _error;

          var _temp10 = _catch(function () {
            return Promise.resolve(response.text()).then(function (body) {
              _error = _extends({}, new Error(body), convertResponse(response, body));
            });
          }, function () {
            // Error parsing response, so we'll just use what we have
            _error = _extends({}, new Error(), convertResponse(response));
          });

          return _temp10 && _temp10.then ? _temp10.then(_temp9) : _temp9(_temp10);
        }
      }();

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8));
    } catch (e) {
      return Promise.reject(e);
    }
  }), catchError(function (error) {
    var _errorTransform;

    var transformed = (_errorTransform = errorTransform === null || errorTransform === void 0 ? void 0 : errorTransform(error)) !== null && _errorTransform !== void 0 ? _errorTransform : error;
    return throwError(transformed);
  }));
}

export default http;
export { ContentTypes };
//# sourceMappingURL=httprx.esm.js.map
